import React from 'react';
import clsx from 'clsx';

const variants = {
  default: 'bg-bg-tertiary text-text-secondary',
  profit: 'bg-profit/10 text-profit',
  loss: 'bg-loss/10 text-loss',
  warning: 'bg-warning/10 text-warning',
  primary: 'bg-accent-primary/10 text-accent-primary',
};

const sizes = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-0.5 text-xs',
  lg: 'px-3 py-1 text-sm',
};

export default function Badge({
  children,
  variant = 'default',
  size = 'md',
  className,
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded',
        variants[variant],
        sizes[size],
        className
      )}
    >
      {children}
    </span>
  );
}
